const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

/**
 * Показывает объём памяти в единицах, в которых о нём удобно рассуждать:
 * мегабайты для рабочих значений и гигабайты для крупных.
 */
export function formatBytes(value?: number | null): string {
	if (!Number.isFinite(value)) return "—";

	const bytes = Number(value);
	const sign = bytes < 0 ? "-" : "";
	const absolute = Math.abs(bytes);

	if (absolute >= GB) return `${sign}${(absolute / GB).toFixed(2)} GB`;
	if (absolute >= MB) return `${sign}${Math.round(absolute / MB)} MB`;
	if (absolute >= KB) return `${sign}${Math.round(absolute / KB)} KB`;

	return `${sign}${absolute} B`;
}

/**
 * Прирост показывается со знаком: направление изменения здесь важнее величины.
 */
export function formatDelta(value?: number | null): string {
	if (!Number.isFinite(value) || value === 0) return "—";
	return `${Number(value) > 0 ? "+" : ""}${formatBytes(value)}`;
}

export function toMegabytes(value?: number | null): number {
	if (!Number.isFinite(value)) return 0;
	return Math.round((Number(value) / MB) * 10) / 10;
}

export function formatTime(ts?: number | null): string {
	if (!Number.isFinite(ts)) return "—";

	return new Date(Number(ts)).toLocaleTimeString([], {
		hour: "2-digit",
		minute: "2-digit",
	});
}

export function formatDateTime(ts?: number | null): string {
	if (!Number.isFinite(ts)) return "—";

	return new Date(Number(ts)).toLocaleString([], {
		day: "2-digit",
		month: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
	});
}

export function formatDuration(ms?: number | null): string {
	if (!Number.isFinite(ms)) return "—";

	const value = Number(ms);
	if (value < 1000) return `${Math.round(value)} ms`;

	return `${(value / 1000).toFixed(1)} s`;
}

export function formatPercent(value?: number | null): string {
	if (value === null || value === undefined || !Number.isFinite(value)) {
		return "—";
	}

	return `${Number(value) > 0 ? "+" : ""}${Math.round(Number(value))}%`;
}

export function formatNumber(value?: number | null): string {
	if (!Number.isFinite(value)) return "—";
	return Number(value).toLocaleString();
}
